import { useCallback, useRef } from 'react';

// import useOutsideClick from '../../../hooks/useOutsideClick';

import {
  CloseButton,
  CloseIconRedNew,
  ModalBody,
  ModalBodyContainter,
  ModalHeader,
  ModalSubmitButton,
  ModalTitle,
  StyledChildModal,
  StyledModalContent,
} from './modal.style';

const ChildModal = (props) => {
  const {
    isOpen = false,
    onClose = () => {},
    children,
    title = '',
    color = 'primary',
    submitBtnText = 'Save',
    isBtnEnabled = false,
    isNotCapitalize,
    isClosedButton = false,
    icon,
  } = props;
  const node = useRef(null);

  const handleCloseModal = useCallback(() => {
    onClose();
  }, [onClose]);

  document.onkeydown = (e) => {
    e = e || window.event;
    if (e.keyCode === 27) {
      handleCloseModal();
    }
  };

  const renderCloseButton = () => {
    return (
      <CloseButton varient="normal" onClick={handleCloseModal}>
        <CloseIconRedNew />
      </CloseButton>
    );
  };

  const onClick = useCallback(() => {
    handleCloseModal();
  }, [handleCloseModal]);

  return (
    <>
      <StyledChildModal isOpen={isOpen}>
        <StyledModalContent ref={node}>
          <ModalBodyContainter color={color} className="hide-scroll-bar">
            <ModalBody>
              {title && (
                <ModalHeader>
                  <ModalTitle size="header3" isNotCapitalize={isNotCapitalize} color={color}>
                    {title}
                  </ModalTitle>
                  {!isClosedButton && icon}
                  {isClosedButton && renderCloseButton()}
                </ModalHeader>
              )}
              {children}
            </ModalBody>
          </ModalBodyContainter>
          {isBtnEnabled && (
            <ModalSubmitButton color={'primary'} onClick={onClick}>
              {submitBtnText}
            </ModalSubmitButton>
          )}
        </StyledModalContent>
      </StyledChildModal>
    </>
  );
};

export default ChildModal;
